/* Sélecteur « Mon spa » — gamme → modèle, persistance cookie + localStorage.
   Expose window.CalderaSpa { get, set, clear, open, MODELS } et l'événement 'spa:changed'. */
(function () {
  'use strict';
  var LS = 'calderabis_spa';
  var CK = 'spa_sel';
  var GAMME_ORDER = ['Utopia', 'Paradise', 'Vacanza', 'Fantasy', 'Sommum', 'Spa de nage'];
  var GAMMES = {
    'Utopia':      { sub: 'Série thérapeutique de luxe',      accent: '#0e7c86' },
    'Paradise':    { sub: 'Série thérapeutique premium',      accent: '#1f6f5c' },
    'Vacanza':     { sub: 'Série essentielle',                accent: '#2b6cb0' },
    'Fantasy':     { sub: 'Compacts, prêts à poser',          accent: '#8a5a9e' },
    'Sommum':      { sub: 'Signature Sommum Wellness',        accent: '#b08948' },
    'Spa de nage': { sub: 'Endless Pools — nage & bien-être', accent: '#0b7285' }
  };

  /* Modeles dont la CARTOUCHE DE FILTRE depend de l'annee de production : pour eux seulement, on
     insere une etape « quelle annee ? » apres le choix du modele, avec le lien vers la page numero
     de serie. Ailleurs le modal se ferme aussitot comme avant — pas de clic en plus pour rien.
     Etabli le 18/08 avec sources (cf. calderabis-nuit-journal.md It.19) :
       Cantabria  74817 (2009 -> mi-2014)  |  73722 (a partir du T3 2014)
       Elation    avant 2005 : cartouche hors catalogue  |  2005+ : 73722
       Hawaiian   avant 2003 : hors catalogue            |  2003-2005 : 73531
       Moorea     avant 2003 : hors catalogue            |  2003+ : 73531
       Serie C    deux cartouches possibles, dont une hors catalogue
     Ajouter un handle ici si une nouvelle bascule d'annee est documentee. */
  var ANNEE_DECIDE = {
    'utopia-cantabria': 'Le Cantabria a changé de cartouche en cours de série : réf. 74817 de 2009 à mi-2014, réf. 73722 à partir du 3ᵉ trimestre 2014. Les deux ne sont pas interchangeables.',
    'utopia-elation': "À partir de 2005, l'Elation prend le filtre 100SQ (réf. 73722). Les modèles antérieurs prennent une cartouche que nous ne référençons pas encore.",
    'paradise-hawaiian': "De 2003 à 2005, le Hawaiian prend le filtre 75SQ (réf. 73531). Avant 2003, c'est une cartouche différente.",
    'paradise-moorea': 'À partir de 2003, le Moorea prend le filtre 75SQ (réf. 73531). Avant 2003, c’est une cartouche différente.',
    'serie-c-c-30': "Deux cartouches sont possibles selon l'année de production, dont une que nous ne référençons pas encore.",
    'serie-c-c-30s': "Deux cartouches sont possibles selon l'année de production, dont une que nous ne référençons pas encore.",
    'serie-c-c-45': "Deux cartouches sont possibles selon l'année de production, dont une que nous ne référençons pas encore.",
    'serie-c-c-45s': "Deux cartouches sont possibles selon l'année de production, dont une que nous ne référençons pas encore."
  };
  var URL_SERIE = '/pages/numero-de-serie-spa-caldera';

  /* ===================== NUMERO DE SERIE =====================
     Source : `datacaldera/data/01_tableaux/spas.csv` et son
     equivalent Fantasy / Endless Pools -- l'index complet du portail
     de service Watkins, deja aspire. Chaque ligne du CSV est une URL
     `calderaserviceportal.watkinsmfg.com/Spa/<Nom CODE>/<annee>`.
     Le guide papier de 2016 n'en donnait que 18 ; le CSV en donne 36,
     avec les annees de production. Rien n'est deduit.

     Format : code -> [nom, premiere annee, derniere annee]. Les annees
     servent a dire l'annee du spa ET a signaler une saisie douteuse. */
  var SN_CALDERA = {
    ASM:  ["Aspire",      2004, 2008],
    ASP:  ["Aspire",      2026, 2026],
    AVH:  ["Aventine",    2006, 2026],
    BLM:  ["Bloom",       2026, 2026],
    C30:  ["C-30",        2007, 2009],
    C45:  ["C-45",        2007, 2009],
    CAB:  ["Cantabria",   2009, 2026],
    CEL:  ["Celio",       2014, 2026],
    CIM:  ["Cima",        2010, 2012],
    CPT:  ["Capitolo",    2012, 2026],
    CUH:  ["Cumberland",  2006, 2009],
    ELM:  ["Elation",     2003, 2014],
    EMG:  ["Emerge",      2025, 2026],
    ENT:  ["Entice",      2026, 2026],
    FLB:  ["Florence",    2018, 2026],
    GEB:  ["Geneva",      2003, 2026],
    HAA:  ["Hawaiian",    2007, 2010],
    INV:  ["Invite",      2026, 2026],
    KAA:  ["Kauai",       2003, 2026],
    LIN:  ["Lina",        2010, 2012],
    MAA:  ["Makena",      2013, 2026],
    MOA:  ["Moorea",      2006, 2010],
    MRA:  ["Martinique",  2003, 2026],
    MRN:  ["Marino",      2010, 2026],
    NIB:  ["Niagara",     2003, 2026],
    OLH:  ["Olympia",     2006, 2009],
    PLT:  ["Palatino",    2010, 2026],
    PRB:  ["Provence",    2018, 2021],
    RAV:  ["Ravello",     2022, 2026],
    REU:  ["Réunion",     2019, 2026],
    SAA:  ["Salina",      2011, 2026],
    SEY:  ["Seychelles",  2019, 2026],
    SPL:  ["Splendor",    2026, 2026],
    TAB:  ["Tahitian",    2003, 2026],
    VNT:  ["Vanto",       2011, 2026],
  };
  /* 4 caracteres : a tester AVANT les 3, sinon `C30S` se lit `C30`. */
  var SN_CALDERA4 = {
    C30S:  ["C-30S",  2007, 2009],
    C45S:  ["C-45S",  2007, 2009],
  };
  /* Portail Fantasy : tous les modeles y portent `FAN`. Ce code ne dit
     donc que la GAMME -- on propose alors les 8 modeles. */
  var SN_FANTASY = ["Aspire", "Bloom", "Drift", "Embrace", "Enamor", "Entice", "Invite", "Splendor"];
  /* SOMMUM — sa marque, construite par Watkins en white label sous les codes PLA.
     Le code n'est jamais rendu au client : seul le nom commercial sort. */
  var SN_SOMMUM = { '34L': 'Aura', '42L': 'Léthé', '42NL': 'Olympe', '40DL': 'Plénitude' };

  var SN_ENDLESS = ["E2000", "X2000", "E500", "E550", "E700", "X200", "X500", "R120", "R200", "R220", "R500"];

  /* F=2004 ... U=2016. I, O et Q ne sont pas utilises (confusion avec 1 et 0). */
  /* 🛑 F -> U est DOCUMENTE (PDF Watkins « How To Read a Serial Number »).
     A -> E et V -> W sont une EXTRAPOLATION de la meme suite, reprise du decodeur
     de « H - dossier site internet data » (04/09). I, O et Q restent sautes.
     Pourquoi on l'adopte : `spas.csv` liste des Geneva, Niagara, Tahitian,
     Martinique et Kauai des **2003**, que la table documentee ne savait pas
     decoder ; et 2017, que j'annoncais indecodable, devient `V`.
     Ce n'est pas ecrit dans un document Watkins : c'est deduit, et c'est dit. */
  var SERIE_ANNEE = { A: 1999, B: 2000, C: 2001, D: 2002, E: 2003,
                      F: 2004, G: 2005, H: 2006, J: 2007, K: 2008, L: 2009, M: 2010,
                      N: 2011, P: 2012, R: 2013, S: 2014, T: 2015, U: 2016,
                      V: 2017, W: 2018 };
  /* Les annees hors du document : on les rend, en le signalant. */
  var SERIE_ANNEE_DEDUITE = { A: 1, B: 1, C: 1, D: 1, E: 1, V: 1, W: 1 };
  var SERIE_TRIM = { '1': 'janvier – mars', '2': 'avril – juin',
                     '3': 'juillet – septembre', '4': 'octobre – décembre' };
  /* D = Domestique US, C = Canada, E = Export 50 Hz. Sa spec insiste :
     « E = Export 50Hz -- c'est notre marche en France ». Un spa domestique US
     arrive en France explique bien des pannes electriques. */
  var SERIE_MARCHE = { D: 'Domestique US', C: 'Canada', E: 'Export 50 Hz' };

  /* Le 3e caractere est la lettre de SERIE pour Utopia et Paradise -- documente
     dans `CALE-HowToReadASerialNumber.pdf` et verifie sur les 18 codes du guide :
     les 4 Utopia finissent tous par B, les 4 Paradise tous par A.
     Les Vacanza n'en ont pas (3 lettres de modele) : absentes d'ici a dessein. */
  var SERIE_GAMME = { B: 'Utopia', A: 'Paradise' };

  /* Le CSV donne les annees de production de chaque modele : on s'en sert pour
     signaler une saisie douteuse, sans jamais refuser. Un Cima annonce en 2020
     alors qu'il n'a ete produit que de 2010 a 2012, c'est presque toujours une
     faute de frappe -- mais c'est au client de trancher, pas a nous. */
  function plausible(res, fiche) {
    if (fiche && res.annee && (res.annee < fiche[1] - 1 || res.annee > fiche[2] + 1)) {
      res.doute = fiche[1] + '–' + fiche[2];
    }
    return res;
  }

  /* Endless Pools : on lit la fin par la DROITE.
     ...19 E 4 18 1001  ->  annee modele, electrique, trimestre, annee fab, sequence.
     Lire par la droite rend la profondeur (52/58/50) et le `3P` indifferents,
     alors qu'une lecture de gauche a droite obligerait a les deviner. */
  function decoderEndless(sn) {
    var mod = null;
    for (var i = 0; i < SN_ENDLESS.length; i++) {
      if (sn.indexOf('EP' + SN_ENDLESS[i]) === 0) { mod = SN_ENDLESS[i]; break; }
    }
    if (!mod) return { erreur: 'code', code: sn.slice(0, 6) };
    if (sn.length < 12) return { erreur: 'court' };
    var seq = sn.slice(-4), fab = sn.slice(-6, -4), trim = sn.slice(-7, -6);
    var elec = sn.slice(-8, -7), am = sn.slice(-10, -8);
    if (!/^\d{2}$/.test(am) || !/^\d$/.test(trim)) return { erreur: 'format' };
    return {
      nom: mod, code: 'EP' + mod, marque: 'Endless Pools', format: 'endless',
      annee_modele: 2000 + parseInt(am, 10),
      // l'annee de FABRICATION fait foi, comme pour Caldera
      annee: /^\d{2}$/.test(fab) ? 2000 + parseInt(fab, 10) : 2000 + parseInt(am, 10),
      marche: SERIE_MARCHE[elec] || null,
      trimestre: SERIE_TRIM[trim] || null,
      segments: [['EP', 'marque'], [mod, 'modèle'],
                 [am, 'millésime'], [elec, 'marché'], [trim, 'trimestre'],
                 [fab, 'année de fabr.'], [seq, 'séquence', 1]]
    };
  }

  function decoderSerie(brut) {
    var sn = String(brut || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (sn.length < 8) return { erreur: 'court' };

    if (sn.indexOf('EP') === 0) return decoderEndless(sn);

    /* --- SOMMUM (PLA) ---
       🛑 On ne decode QUE le modele. La numerotation Sommum n'est documentee
       nulle part : le manuel White Label PLA dit ou est l'etiquette, pas comment
       lire le numero, et il n'existe pas de « How To Read a Serial Number »
       White Label. Annoncer une annee ici reviendrait a l'inventer.
       Les quatre codes, eux, sont sus (elle les a donnes le 28/08, et les noms
       de ses fiches techniques les confirment). */
    if (sn.indexOf('PLA') === 0) {
      var suf = null;
      // le plus long d'abord : `42NL` avant `42L`, sinon on perd l'Olympe
      ['42NL', '40DL', '34L', '42L'].forEach(function (k) {
        if (!suf && sn.indexOf('PLA' + k) === 0) suf = k;
      });
      // on garde la saisie telle quelle : sur un suffixe inconnu, afficher
      // « PLA » tout court n'aide personne a comprendre ce qui a ete tape.
      var rs = { marque: 'Sommum', code: suf ? 'PLA' + suf : sn, sans_annee: true };
      if (suf) rs.nom = SN_SOMMUM[suf]; else rs.gamme_seule = 'Sommum';
      return rs;
    }

    // 🛑 la Serie C se teste sur 4 caracteres AVANT les 3 : sinon `C30SE1F1001`
    // serait lu `C30` + `S` pris pour la lettre d'electrique.
    // Le decoupage est : C30S | E | 1 | F | 1001 -- prefixe(4), electrique,
    // trimestre, annee, sequence. D'ou les positions 5 et 6 ci-dessous.
    // ⚠️ Le commentaire portait auparavant `C30S1F1001`, un numero MALFORME (sans
    // la lettre d'electrique) : teste tel quel le 04/09, il echoue a juste titre,
    // et m'a fait croire un instant a un bug du decodeur. Un exemple faux dans un
    // commentaire coute un diagnostic.
    var c4 = sn.slice(0, 4);
    if (SN_CALDERA4[c4]) {
      var t4 = SERIE_TRIM[sn.charAt(5)] || null;
      var a4 = SERIE_ANNEE[sn.charAt(6)];
      return a4 ? plausible({ nom: SN_CALDERA4[c4][0], code: c4, annee: a4,
                              trimestre: t4, format: 'ancien' }, SN_CALDERA4[c4])
                : { erreur: 'annee', nom: SN_CALDERA4[c4][0], lettre: sn.charAt(6) };
    }

    var code = sn.slice(0, 3);
    var fiche = SN_CALDERA[code];
    var nom = fiche ? fiche[0] : null;

    // Modele inconnu ? On continue quand meme : la gamme et l'annee restent
    // lisibles, et une gamme + une annee valent bien mieux qu'un refus sec.
    var res = { code: code };
    if (nom) {
      res.nom = nom;
    } else if (code === 'FAN') {
      // portail Fantasy : `FAN` est le code de la GAMME, pas du modele
      res.gamme_seule = 'Fantasy';
    } else if (/^[A-Z]{2}$/.test(code.slice(0, 2)) && SERIE_GAMME[code.charAt(2)]) {
      res.gamme_seule = SERIE_GAMME[code.charAt(2)];
    } else {
      res.inconnu = true;
    }
    /* 🛑 La longueur du prefixe se DEDUIT, elle ne se suppose pas. Le format
       recent place l'annee sur deux chiffres juste apres le prefixe, qui fait
       3 OU 4 caracteres. Constate le 04/09 sur un vrai numero, `PVTA24E2241069` :
       en lisant toujours en position 3-4 on y trouvait « A2 », donc pas deux
       chiffres, donc le code basculait sur l'ANCIEN format et prenait le « 4 »
       de la position 5 pour une lettre d'annee. Le chemin `SN_CALDERA4` ne
       rattrape que les 4-caracteres CONNUS ; un inconnu tombait dans le trou. */
    var pl = /^[0-9]{2}$/.test(sn.slice(4, 6)) ? 4
           : (/^[0-9]{2}$/.test(sn.slice(3, 5)) ? 3 : 0);
    if (pl) {
      // NOUVEAU format : CAB 19 D 2 18 1001  (ou PVTA 24 E 2 24 1069)
      // CAB | 19 | D | 2 | 18 | 1001
      //       ^annee modele  ^trim ^annee de FABRICATION
      var pre = sn.slice(0, pl);
      res.code = pre;
      res.annee_modele = 2000 + parseInt(sn.slice(pl, pl + 2), 10);
      res.marche = SERIE_MARCHE[sn.charAt(pl + 2)] || null;
      res.trimestre = SERIE_TRIM[sn.charAt(pl + 3)] || null;
      var af = sn.slice(pl + 4, pl + 6);
      // 🛑 c'est l'annee de FABRICATION qu'elle veut voir (sa spec du 04/09)
      res.annee = /^[0-9]{2}$/.test(af) ? 2000 + parseInt(af, 10) : res.annee_modele;
      res.format = 'recent';
      res.segments = [[pre, 'modèle'], [sn.slice(pl, pl + 2), 'millésime'],
                      [sn.charAt(pl + 2), 'marché'], [sn.charAt(pl + 3), 'trimestre'],
                      [af, 'année de fabr.'], [sn.slice(pl + 6), 'séquence', 1]];
    } else {
      // ANCIEN format : GEB E 1 F 1001
      res.marche = SERIE_MARCHE[sn.charAt(3)] || null;
      res.trimestre = SERIE_TRIM[sn.charAt(4)] || null;
      var a = SERIE_ANNEE[sn.charAt(5)];
      if (a && SERIE_ANNEE_DEDUITE[sn.charAt(5)]) res.annee_deduite = true;
      if (!a) return { erreur: 'annee', nom: nom, lettre: sn.charAt(5),
                       /* V = 2017 et W = 2018 sont desormais decodees. Ne
                          restent que X, Y et Z, qui ne correspondent a rien de
                          connu -- ni documente, ni extrapolable. */
                       transition: 'XYZ'.indexOf(sn.charAt(5)) >= 0 };
      // (l'annee vient de la table F..U, elle ne depend pas du modele)
      res.annee = a;
      res.format = 'ancien';
      res.segments = [[code, 'modèle'], [sn.charAt(3), 'marché'],
                      [sn.charAt(4), 'trimestre'], [sn.charAt(5), 'année (' + a + ')'],
                      [sn.slice(6), 'séquence', 1]];
    }
    return plausible(res, fiche);
  }

  /* Du nom decode au modele du catalogue. On compare sans accent ni casse : ses
     entrees portent « Réunion », « Léthé »... et un numero de serie est en ASCII. */
  function normNom(x) {
    var v = String(x == null ? '' : x).toLowerCase();
    // on retire les diacritiques : ses entrees portent « Reunion », « Lethe »...
    // alors qu'un numero de serie est en ASCII pur.
    return v.normalize ? v.normalize('NFD').replace(/[̀-ͯ]/g, '') : v;
  }
  function modeleParNom(nom) {
    var cible = normNom(nom), trouve = null;
    MODELS.forEach(function (m) { if (!trouve && normNom(m.nom) === cible) trouve = m; });
    return trouve;
  }

  var MODELS = [];
  try {
    var el = document.getElementById('spa-models-data');
    if (el) MODELS = JSON.parse(el.textContent || '[]');
    // La Liquid termine le tableau par une sentinelle `null` (evite la virgule finale) et peut
    // repeter une entree via la liste de debordement : on nettoie et on dedoublonne par handle.
    var vus = {};
    MODELS = MODELS.filter(function (m) {
      if (!m || !m.handle || vus[m.handle]) return false;
      vus[m.handle] = 1; return true;
    });
  } catch (e) { MODELS = []; }
  MODELS.sort(function (a, b) { return (a.ordre || 0) - (b.ordre || 0); });
  var BY_HANDLE = {};
  MODELS.forEach(function (m) { BY_HANDLE[m.handle] = m; });
  /* Les pages « pièces détachées <modèle> », injectées par le snippet.
     Table vide = comportement d'avant : on se contente de fermer la modale. */
  var PAGES = {};
  var ANNEES = {};
  try {
    var pel = document.getElementById('spa-pages-data');
    if (pel) {
      (JSON.parse(pel.textContent) || []).forEach(function (p) {
        if (!p || !p.spa) return;
        if (p.url) PAGES[p.spa] = p.url;
        // « 2009 à 2026 » -> [2009, 2026]. Sans plage, pas d'étape année.
        var a = String(p.annees || '').match(/(\d{4})\D+(\d{4})/);
        if (a && +a[2] > +a[1]) ANNEES[p.spa] = [+a[1], +a[2]];
      });
    }
  } catch (e) { PAGES = {}; }

  var GAMME_IMG = {};
  MODELS.forEach(function (m) { if (m.image && !GAMME_IMG[m.gamme]) GAMME_IMG[m.gamme] = m.image; });

  /* ---------- persistance ---------- */
  function readCookie(name) {
    var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return m ? decodeURIComponent(m.pop()) : '';
  }
  function writeCookie(name, val, days) {
    var d = new Date(); d.setTime(d.getTime() + (days || 365) * 864e5);
    document.cookie = name + '=' + encodeURIComponent(val) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
  }
  function get() {
    try {
      var raw = localStorage.getItem(LS);
      if (raw) return JSON.parse(raw);
    } catch (e) {}
    var h = readCookie(CK);
    return h && BY_HANDLE[h] ? { handle: h, label: BY_HANDLE[h].nom_complet, gamme: BY_HANDLE[h].gamme } : null;
  }
  function set(handle, annee) {
    var m = BY_HANDLE[handle];
    if (!m) return;
    var sel = { handle: handle, label: m.nom_complet, gamme: m.gamme };
    // 🛑 L'annee ne vient QUE d'un numero de serie decode. Un clic sur une
    // vignette n'en fournit pas : on ne l'invente pas, on la laisse absente.
    // Et on ne l'ecrase pas si le nouveau choix n'en apporte pas pour le MEME spa.
    // 🛑 `null` EFFACE l'annee (retour a « toutes les annees ») ; `undefined`
    //    la conserve — un clic sur une vignette ne doit pas la perdre.
    if (annee) sel.annee = annee;
    else if (annee !== null) { var av = get(); if (av && av.handle === handle && av.annee) sel.annee = av.annee; }
    try { localStorage.setItem(LS, JSON.stringify(sel)); } catch (e) {}
    writeCookie(CK, handle, 365);
    renderPills();
    document.dispatchEvent(new CustomEvent('spa:changed', { detail: sel }));
  }
  function clear() {
    try { localStorage.removeItem(LS); } catch (e) {}
    writeCookie(CK, '', -1);
    renderPills();
    document.dispatchEvent(new CustomEvent('spa:changed', { detail: null }));
  }

  /* La tete de modale (accroche + saisie du numero de serie) sert a CHOISIR son spa.
     Une fois le choix fait, elle n'a plus d'objet et fait doublon avec le CTA du centre :
     on la retire de la seconde etape (sa demande du 15/09). */
  function majTete(apresChoix) {
    if (!modal) return;
    var eb = modal.querySelector('[data-spa-eyebrow]');
    var sn = modal.querySelector('[data-spa-sn]');
    modal.classList.toggle('is-apres', !!apresChoix);
    if (eb) eb.hidden = !!apresChoix;
    if (sn) sn.hidden = !!apresChoix;
  }

  /* ---------- pills ---------- */
  function renderPills() {
    var sel = get();
    document.querySelectorAll('.spa-pill').forEach(function (p) {
      var lead = p.querySelector('[data-spa-lead]');
      var val = p.querySelector('[data-spa-val]');
      if (sel) {
        p.classList.add('is-set');
        if (lead) { lead.textContent = 'Mon spa'; lead.hidden = false; }
        /* 🛑 Le nom SEUL sur la pastille : avec la gamme, « Paradise Martinique ·
           2015 » faisait 187 px et ne laissait que 7 px avant « Guide du Spa »
           (mesure du 16/09). Le nom complet reste dans l'aria-label ci-dessous. */
        var court = BY_HANDLE[sel.handle] ? BY_HANDLE[sel.handle].nom : sel.label;
        var lib = court + (sel.annee ? ' · ' + sel.annee : '');
        var complet = sel.label + (sel.annee ? ' · ' + sel.annee : '');
        if (val) { val.textContent = lib; val.hidden = false; }
        p.setAttribute('aria-label', 'Mon spa : ' + complet + ' — modifier');
      } else {
        p.classList.remove('is-set');
        if (lead) { lead.textContent = 'Mon spa'; lead.hidden = false; }
        if (val) { val.textContent = ''; val.hidden = true; }
        p.setAttribute('aria-label', 'Mon spa : indiquez votre modèle pour ne voir que ce qui est compatible');
      }
    });
    // majLienPage est une declaration de fonction (donc hissee) : l'appeler ici garantit
    // que le lien du pied suit TOUT changement de spa, pas seulement l'ouverture.
    majLienPage();
    // Même raison pour « Effacer mon choix » : il n'était calculé qu'à l'ouverture,
    // donc il restait caché quand on choisissait son spa depuis un état vide
    // (son constat du 15/09 sur Paradise et Vacanza).
    if (clearBtn) clearBtn.hidden = !sel;
  }

  /* ---------- modal ---------- */
  var modal = document.getElementById('spa-modal');
  var body = modal && modal.querySelector('[data-spa-body]');
  var titleEl = modal && modal.querySelector('[data-spa-title]');
  var subEl = modal && modal.querySelector('[data-spa-sub]');
  var backBtn = modal && modal.querySelector('[data-spa-back]');
  var clearBtn = modal && modal.querySelector('[data-spa-clear]');
  var lastFocus = null;

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function groupByGamme() {
    var g = {};
    MODELS.forEach(function (m) { (g[m.gamme] = g[m.gamme] || []).push(m); });
    return g;
  }

  function renderGammes() {
    majTete(false);
    if (!body) return;
    if (titleEl) titleEl.textContent = 'Quel est votre spa ?';
    if (subEl) subEl.textContent = 'Indiquez-le une fois. Ensuite, dans chaque rayon du site, nous n’affichons que ce qui va sur votre modèle.';
    if (backBtn) backBtn.hidden = true;
    var groups = groupByGamme();
    var sel = get();
    var order = GAMME_ORDER.filter(function (k) { return groups[k]; })
      .concat(Object.keys(groups).filter(function (k) { return GAMME_ORDER.indexOf(k) < 0; }));
    var html = '<div class="spa-grid" role="list">';
    order.forEach(function (gname) {
      var meta = GAMMES[gname] || { sub: '', accent: '#0e7c86' };
      var n = groups[gname].length;
      var isCur = sel && sel.gamme === gname;
      var img = GAMME_IMG[gname];
      var media = img
        ? '<span class="spa-gcard__media" style="background-image:url(' + esc(img) + ')"></span>'
        : '<span class="spa-gcard__media"><span class="spa-gcard__ph" style="background:' + meta.accent + '">' + esc(gname) + '</span></span>';
      html += '<button type="button" class="spa-gcard' + (isCur ? ' is-current' : '') + '" role="listitem" data-gamme="' + esc(gname) + '">' +
        media +
        '<span class="spa-gcard__b"><span class="spa-gcard__t">' + esc(gname) + '</span>' +
        '<span class="spa-gcard__s">' + esc(meta.sub) + '</span>' +
        '<span class="spa-gcard__n">' + n + ' modèle' + (n > 1 ? 's' : '') + ' ›</span></span>' +
        '</button>';
    });
    html += '</div>';
    body.innerHTML = html;
    body.querySelectorAll('[data-gamme]').forEach(function (b) {
      b.addEventListener('click', function () { renderModels(b.getAttribute('data-gamme')); });
    });
  }

  function renderModels(gname) {
    majTete(false);
    if (!body) return;
    var meta = GAMMES[gname] || { accent: '#0e7c86' };
    if (titleEl) titleEl.textContent = gname;
    if (subEl) subEl.textContent = 'Sélectionnez votre modèle exact.';
    if (backBtn) backBtn.hidden = false;
    var sel = get();
    var list = MODELS.filter(function (m) { return m.gamme === gname; });
    var html = '<div class="spa-grid" role="list">';
    list.forEach(function (m) {
      var isCur = sel && sel.handle === m.handle;
      var tag = m.actif ? '' : '<span class="spa-mcard__tag">Ancien modèle</span>';
      var media = m.image
        ? '<span class="spa-mcard__media" style="background-image:url(' + esc(m.image) + ')">' + tag + '</span>'
        : '<span class="spa-mcard__media"><span class="spa-mcard__ph" style="background:' + meta.accent + '">' + esc(m.nom) + '</span>' + tag + '</span>';
      var places = m.places ? (m.places + ' places') : '';
      html += '<button type="button" class="spa-mcard' + (isCur ? ' is-current' : '') + '" role="listitem" data-handle="' + esc(m.handle) + '">' +
        media +
        '<span class="spa-mcard__b"><span class="spa-mcard__t">' + esc(m.nom) + '</span>' +
        (places ? '<span class="spa-mcard__m">' + esc(places) + '</span>' : '') +
        '</span></button>';
    });
    html += '</div>';
    body.innerHTML = html;
    body.querySelectorAll('[data-handle]').forEach(function (b) {
      b.addEventListener('click', function () {
        var h = b.getAttribute('data-handle');
        set(h);
        // Le choix est enregistre dans tous les cas ; on n'ajoute une etape que si l'annee decide.
        // Sinon, quand une page existe, on la propose : fermer sans rien dire laissait
        // croire qu'il ne s'etait rien passe (son constat du 15/09).
        // 🛑 La PAGE d'abord : l'année s'y précise ensuite, si on la connaît.
        // L'ancien ordre demandait l'année AVANT de rien montrer, et son libellé
        // laissait croire qu'on ne voyait pas ses pièces sans elle (son constat).
        // Le MEME écran pour les 51 modèles : 16 d'entre eux voyaient la modale se
        // fermer sans un mot (son constat du 15/09). renderConfirm sait désormais
        // où mener même sans page modèle.
        renderConfirm(h);
      });
    });
    if (backBtn) backBtn.onclick = renderGammes;
  }

  /* Confirmation : elle vient de choisir son spa, on lui donne le chemin le plus court vers
     TOUT ce qui lui va. Les classes .spa-annee existent deja : rien a ajouter au CSS. */
  /* Le selecteur ENREGISTRE, il n'oriente pas : plus de lien vers une page de
     pieces (sa decision du 16/09). L'ecran sert a confirmer et, quand on la
     connait, a preciser l'annee — c'est elle qui fait filtrer les collections. */
  function renderConfirm(handle) {
    if (!body) { close(); return; }
    majTete(true);
    var m = BY_HANDLE[handle];
    var nom = m ? ((m.gamme ? m.gamme + ' ' : '') + m.nom) : 'votre spa';
    if (titleEl) titleEl.textContent = nom;
    if (subEl) subEl.textContent = "C’est noté. Dans chaque rayon du site, vous ne verrez plus que les pièces qui vont sur votre spa.";
    if (backBtn) backBtn.hidden = false;
    var pl = ANNEES[handle];
    var cour = get();
    var opts = '<option value="">toutes les années</option>';
    if (pl) { for (var y = pl[1]; y >= pl[0]; y--) {
      opts += '<option value="' + y + '"' + (cour && +cour.annee === y ? ' selected' : '') + '>' + y + '</option>'; } }
    var idAn = 'spa-an-' + Math.random().toString(36).slice(2, 7);
    body.innerHTML =
      '<div class="spa-annee">' +
        (pl ? '<div class="spa-an2"><label for="' + idAn + '">Année de mon spa <em>(facultatif)</em></label>' +
              '<select id="' + idAn + '" data-an>' + opts + '</select></div>' : '') +
        '<div class="spa-annee__act">' +
          '<button type="button" class="spa-annee__btn" data-spa-annee-ok>Termin\u00e9</button>' +
        '</div></div>';
    var selAn = body.querySelector('[data-an]');
    if (selAn) selAn.addEventListener('change', function () {
      set(handle, selAn.value ? +selAn.value : null);
    });
    var ok = body.querySelector('[data-spa-annee-ok]');
    if (ok) { ok.addEventListener('click', close); ok.focus(); }
    if (backBtn) backBtn.onclick = function () { renderModels(m ? m.gamme : null); };
  }

  /* Etape « quelle annee ? » — n'apparait que pour les modeles de ANNEE_DECIDE. C'est le moment
     logique pour le numero de serie : il ne sert pas a CHOISIR son spa, il sert a en connaitre
     l'annee, et l'annee ne devient un sujet qu'une fois le modele connu. */
  function renderAnnee(handle) {
    if (!body) return;
    majTete(true);
    var m = null;
    MODELS.forEach(function (x) { if (x.handle === handle) m = x; });
    var nom = m ? ((m.gamme ? m.gamme + ' ' : '') + m.nom) : 'votre spa';
    if (titleEl) titleEl.textContent = nom;
    // La confirmation reste — mais en une ligne, pas en bloc. Le detail du changement de
    // cartouche vit sur la page du modele, ou il a sa place.
    if (subEl) subEl.innerHTML = "Votre spa est enregistré.<br>Selon l'année, la cartouche n'est pas la même.";
    if (backBtn) backBtn.hidden = false;
    body.innerHTML =
      '<div class="spa-annee"><div class="spa-annee__act">' +
        '<a class="spa-annee__btn" href="' + URL_SERIE + '">Trouver l’année par le numéro de série</a>' +
        (PAGES[handle]
          ? '<a class="spa-annee__skip" href="' + esc(PAGES[handle]) + '">Je connais mon année, voir mes pièces</a>'
          : '<button type="button" class="spa-annee__skip" data-spa-annee-ok>Je connais mon année, continuer</button>') +
      '</div></div>';
    // Les deux actions menent desormais quelque part ; le lien du pied repeterait
    // la seconde. On ne le garde que si le modele n'a pas de page.
    majLienPage();
    if (PAGES[handle]) { var lp = modal.querySelector('[data-spa-page]'); if (lp) lp.hidden = true; }
    var ok = body.querySelector('[data-spa-annee-ok]');
    if (ok) ok.addEventListener('click', close);
    if (backBtn) backBtn.onclick = function () { renderModels(m ? m.gamme : null); };
    if (ok) ok.focus();
  }

  /* ---------- le formulaire numero de serie ---------- */
  var snForm = modal && modal.querySelector('[data-spa-sn]');
  var snIn = modal && modal.querySelector('#spa-sn-input');
  var snMsg = modal && modal.querySelector('[data-spa-sn-msg]');
  var SN_AIDE = snMsg ? snMsg.innerHTML : '';

  function snDire(html, etat) {
    if (!snMsg) return;
    snMsg.innerHTML = html;
    snMsg.className = 'spa-sn__aide' + (etat ? ' is-' + etat : '');
  }


  function snChercher() {
    if (!snIn) return;
    var brut = snIn.value.trim();
    if (!brut) { snDire(SN_AIDE, ''); return; }
    var d = decoderSerie(brut);

    if (d.erreur === 'court') {
      snDire('Un numéro de série Watkins fait au moins 10 caractères.', 'ko'); return;
    }
    if (d.erreur === 'annee') {
      /* 🛑 Ne jamais annoncer un modele qu'on n'a pas : « Modèle reconnu : . »
         etait visible a l'ecran le 04/09 sur un numero hors catalogue Caldera. */
      snDire((d.nom
              ? 'Modèle reconnu : <strong>' + esc(d.nom) + '</strong>. '
              : 'Ce numéro ne correspond à <strong>aucun modèle Caldera connu</strong>. ')
           + (d.transition
              ? 'La lettre <strong>' + esc(d.lettre) + '</strong> ne correspond à aucune '
                + 'année connue : la codification Watkins s’arrête à <strong>W = 2018</strong>, '
                + 'après quoi l’année s’écrit sur deux chiffres. Vérifiez la saisie, ou '
                + 'choisissez votre modèle ci-dessous.'
              : 'Mais la lettre d’année <strong>' + esc(d.lettre) + '</strong> ne correspond '
                + 'à rien de documenté : vérifiez la saisie.'), d.transition ? 'ok' : 'ko');
      if (d.transition) { var mm = modeleParNom(d.nom); if (mm) renderModels(mm.gamme); }
      return;
    }

    /* Sommum : le modele est su, l'annee non. On l'ecrit au lieu de la deviner. */
    if (d.sans_annee) {
      var ms = d.nom ? modeleParNom(d.nom) : null;
      if (ms) {
        set(ms.handle);
        snDire('<strong>' + esc((ms.gamme ? ms.gamme + ' ' : '') + ms.nom)
             + '</strong>. Enregistré. <em>L’année n’est pas lisible sur un numéro '
             + 'Sommum : sa numérotation n’est documentée nulle part.</em>', 'ok');
        renderModels(ms.gamme);
      } else {
        snDire('C’est un <strong>Sommum</strong>, mais le code <strong>'
             + esc(d.code) + '</strong> ne correspond à aucun de nos quatre modèles. '
             + '<a href="/pages/contact">Écrivez-nous le numéro complet</a>.', 'ko');
      }
      return;
    }

    var quand = d.annee + (d.trimestre ? ' (' + d.trimestre + ')' : '')
      + (d.annee_modele && d.annee_modele !== d.annee ? ', millésime ' + d.annee_modele : '')
      + (d.marche ? ' · ' + d.marche : '');

    /* 2) la gamme seule : le 3e caractere l'a donnee, le modele exact non.
          On ouvre la grille de cette gamme -- 4 a 10 vignettes au lieu de 51. */
    if (d.gamme_seule) {
      var dispo = MODELS.filter(function (x) { return x.gamme === d.gamme_seule; });
      if (dispo.length) {
        snDire('Votre spa est un <strong>' + esc(d.gamme_seule) + '</strong> de <strong>'
             + quand + '</strong>. Le code <strong>' + esc(d.code) + '</strong> n’est pas dans '
             + 'notre table : désignez votre modèle ci-dessous.', 'ok');
        renderModels(d.gamme_seule);
        return;
      }
    }

    /* 3) ni modele ni gamme : l'annee reste un renseignement utile. */
    if (!d.nom) {
      snDire('Numéro lu : votre spa date de <strong>' + quand + '</strong>. Le code '
           + '<strong>' + esc(d.code) + '</strong> n’est pas dans notre table — choisissez '
           + 'votre gamme ci-dessous, ou <a href="/pages/contact">envoyez-nous le numéro '
           + 'complet</a>.', 'ok');
      renderGammes();
      return;
    }

    /* 1) le modele exact. */
    var m = modeleParNom(d.nom);
    if (!m) {
      snDire('Votre spa est un <strong>' + esc(d.nom) + '</strong> (' + quand + '), mais nous '
           + 'ne le référençons pas. <a href="/pages/contact">Écrivez-nous</a>.', 'ko');
      return;
    }
    // Le doute se dit, il ne bloque pas : le CSV donne les annees de production,
    // et une annee hors de cette plage est presque toujours une faute de frappe.
    snDire('<strong>' + esc((m.gamme ? m.gamme + ' ' : '') + m.nom) + '</strong> — ' + quand
         + '. Enregistré.'
         + (d.doute ? ' <em>À vérifier : ce modèle a été produit de ' + esc(d.doute)
                      + '.</em>' : ''), 'ok');
    snIn.value = '';
    // Meme enregistrement qu'un clic sur une vignette.
    set(m.handle, d.annee);
    /* 🛑 Le numero donne le modele ET l'annee : il n'y a RIEN a demander. On ferme.
       « Une fois le numero rentre, plus de fenetre ; le spa est direct en haut dans
       le selecteur » (16/09). C'est la pastille qui porte la reponse. */
    close();
  }

  if (snForm) {
    snForm.addEventListener('submit', function (e) { e.preventDefault(); snChercher(); });
  }
  if (snIn) {
    // on revient a l'aide des qu'on retouche le champ : un message d'erreur fige ment vite
    snIn.addEventListener('input', function () {
      if (snMsg && snMsg.className !== 'spa-sn__aide') snDire(SN_AIDE, '');
    });
  }

  /* Le lien du pied de modale, pour qui a DEJA choisi son spa : sans lui, il faudrait
     re-cliquer son modele pour retrouver le chemin de sa page. */
  var lienPage = modal && modal.querySelector('[data-spa-page]');
  /* Plus de lien vers une page de pieces : le selecteur enregistre, il n'oriente
     pas (16/09). La fonction reste — elle est appelee a plusieurs endroits — mais
     elle ne fait plus que garder le lien masque. */
  function majLienPage() {
    if (lienPage) lienPage.hidden = true;
  }

  function open(startStep) {
    if (!modal) return;
    lastFocus = document.activeElement;
    var sel = get();
    majLienPage();
    if (sel && startStep !== 'gammes') renderModels(sel.gamme); else renderGammes();
    if (clearBtn) clearBtn.hidden = !sel;
    modal.hidden = false;
    document.body.classList.add('spa-modal-open');
    document.querySelectorAll('.spa-pill').forEach(function (p) { p.setAttribute('aria-expanded', 'true'); });
    var f = modal.querySelector('.spa-card, .spa-mcard, .spa-modal__x');
    if (f) f.focus();
  }
  function close() {
    if (!modal) return;
    modal.hidden = true;
    document.body.classList.remove('spa-modal-open');
    document.querySelectorAll('.spa-pill').forEach(function (p) { p.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- wiring ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-spa-open]');
    if (t) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-spa-close]')) { e.preventDefault(); close(); return; }
  });
  if (backBtn) backBtn.addEventListener('click', renderGammes);
  if (clearBtn) clearBtn.addEventListener('click', function () { clear(); close(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && !modal.hidden) close();
  });

  /* ---------- Compatibilite : la regle d'annee, partagee ---------- */
  /* `compat_annees` accepte `{handle: annee}` (a partir de) ou
     `{handle: [min, max]}` (plage fermee). L'annee du spa ne vient QUE d'un
     numero de serie decode : si elle est inconnue, on ne tranche pas. */
  function anneeConvient(brut, sel) {
    if (!brut || !sel || !sel.annee) return true;
    try {
      var v = JSON.parse(brut)[sel.handle];
      if (!v) return true;
      var mini = v, maxi = null;
      if (Object.prototype.toString.call(v) === '[object Array]') { mini = v[0]; maxi = v[1]; }
      if (mini && sel.annee < mini) return false;
      if (maxi && sel.annee > maxi) return false;
    } catch (e) {}
    return true;
  }

  /* ---------- Filtrage collection « Compatible avec votre spa » ---------- */
  function applyFilter(active) {
    var sel = get(), shown = 0;
    var cards = document.querySelectorAll('[data-compat-universel]');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var li = card.closest('.grid__item') || card.closest('li') || card;
      var universel = card.getAttribute('data-compat-universel') === 'true';
      var ids = (card.getAttribute('data-compat-ids') || '').split(/\s+/).filter(Boolean);
      /* 🛑 La LISTE tranche des qu'elle existe. Avant, `universel ||` la
         court-circuitait : une fiche cochee « tous spas » ET porteuse d'une
         liste s'affichait partout — c'est ce qui sortait la sonde IQ sur un
         Capitolo. « Tous spas » ne vaut donc que SANS liste. */
      var match = ids.length ? (!!sel && ids.indexOf(sel.handle) >= 0) : universel;
      /* Regle d'ANNEE : un equipement (systeme au sel, IQ) n'existe qu'a partir
         d'un millesime, et pas le meme selon le modele — le sel arrive en 2019
         sur Utopia/Paradise mais en 2025 sur Vacanza. `compat_annees` porte la
         premiere annee par modele (source : portail Watkins).
         L'annee du spa ne vient QUE d'un numero de serie decode : si elle est
         inconnue on ne tranche pas, on laisse voir, et la condition ecrite sur
         la carte fait le travail. On ne devine jamais une annee. */
      if (match) match = anneeConvient(card.getAttribute('data-compat-annees'), sel);
      if (active && sel && !match) { li.style.display = 'none'; }
      else { li.style.display = ''; if (li !== card) shown++; }
    }
    return shown;
  }
  /* L'encart « aucun resultat ». Insere APRES la barre : le
     MutationObserver ecoute `childList` sur #ProductGridContainer, y ajouter un
     noeud relancerait updateCompat en boucle. */
  function emptyBox() {
    var box = document.querySelector('[data-spa-compat]');
    if (!box || !box.parentNode) return null;
    var el = document.querySelector('[data-spa-empty]');
    if (!el) {
      el = document.createElement('div');
      el.className = 'spa-empty page-width';
      el.setAttribute('data-spa-empty', '');
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.hidden = true;
      box.parentNode.insertBefore(el, box.nextSibling);
    }
    return el;
  }

  /* La grille remonte au-dessus du premier tableau, UNIQUEMENT quand un spa est
     choisi. Consequence voulue : un robot, qui n'a jamais de spa choisi, voit
     exactement la page d'origine — donc zero effet sur l'indexation.
     Une ancre garde la position de depart pour pouvoir revenir. */
  var gSec = null, gAnchor = null;
  function initReorder() {
    var g = document.getElementById('ProductGridContainer');
    if (!g) return;                       /* pas de grille : rien a monter
                                             (Couvertures, Leve-couvertures) */
    var sec = g.closest('[id^="shopify-section-"]');
    if (!sec || !sec.parentNode) return;
    gSec = sec;
    gAnchor = document.createComment(' position d\'origine de la grille ');
    sec.parentNode.insertBefore(gAnchor, sec);
  }
  function reorder(actif) {
    if (!gSec || !gAnchor || !gAnchor.parentNode) return;
    var parent = gAnchor.parentNode;
    if (!actif) {
      if (gAnchor.nextSibling !== gSec) parent.insertBefore(gSec, gAnchor.nextSibling);
      return;
    }
    /* 🛑 Ne PAS se fier a `children[1]` : les enfants de #MainContent
       comprennent des noeuds qui ne sont pas des sections (NAV, STYLE, SCRIPT).
       Mesure a l'ecran le 08/09 : la grille est alors passee AU-DESSUS de la
       banniere. On ne retient que les `shopify-section-*`, et on laisse la
       banniere en tete : la grille se glisse juste apres elle. */
    var sections = [];
    for (var n = parent.firstElementChild; n; n = n.nextElementSibling) {
      if (/^shopify-section-/.test(n.id || '')) sections.push(n);
    }
    var i = 0;
    if (sections.length && sections[0] !== gSec && /banner|banniere|hero/i.test(sections[0].id)) i = 1;
    var cible = sections[i];
    if (cible && cible !== gSec) parent.insertBefore(gSec, cible);
  }

  function updateCompat() {
    var box = document.querySelector('[data-spa-compat]');
    if (!box) return;
    var sel = get();
    var chip = box.querySelector('[data-spa-compat-chip]');
    var title = box.querySelector('[data-spa-compat-title]');
    var sub = box.querySelector('[data-spa-compat-sub]');
    var tw = box.querySelector('[data-spa-compat-togglewrap]');
    var choose = box.querySelector('[data-spa-compat-choose]');
    var check = box.querySelector('[data-spa-compat-check]');
    if (sel) {
      if (chip) chip.hidden = false;
      if (tw) tw.hidden = false;
      if (choose) choose.hidden = true;
      box.classList.add('is-set');
      var active = check ? check.checked : true;
      var shown = applyFilter(active);
      if (title) title.textContent = sel.label + (sel.annee ? ' · ' + sel.annee : '');
      if (sub) sub.textContent = active ? (shown + ' résultat' + (shown > 1 ? 's' : '')) : 'filtre désactivé';
      reorder(true);
      var vide = emptyBox();
      if (vide) {
        if (active && shown === 0) {
          vide.innerHTML =
            '<p class="spa-empty__t">Aucun produit de cette page ne correspond à votre <strong>'
            + esc(sel.label) + '</strong>.</p>'
            + '<p class="spa-empty__s">Cela peut vouloir dire que nous ne référençons pas encore '
            + 'la pièce pour ce modèle — écrivez-nous, nous vérifions.</p>'
            + '<div class="spa-empty__a">'
            + '<button type="button" class="spa-cta" data-spa-empty-all>Afficher tous les produits</button>'
            + '<button type="button" class="spa-cta spa-cta--ghost" data-spa-open>Changer de spa</button>'
            + '</div>';
          var tout = vide.querySelector('[data-spa-empty-all]');
          if (tout && check) tout.addEventListener('click', function () {
            check.checked = false;
            updateCompat();
          });
          vide.hidden = false;
        } else {
          vide.hidden = true;
        }
      }
    } else {
      if (chip) chip.hidden = true;
      if (tw) tw.hidden = true;
      if (choose) choose.hidden = false;
      box.classList.remove('is-set');
      if (sub) sub.textContent = '';
      applyFilter(false);
      reorder(false);
      var v0 = document.querySelector('[data-spa-empty]');
      if (v0) v0.hidden = true;
    }
  }
  var compatBox = document.querySelector('[data-spa-compat]');
  if (compatBox) {
    initReorder();
    var chk = compatBox.querySelector('[data-spa-compat-check]');
    if (chk) chk.addEventListener('change', updateCompat);
    document.addEventListener('spa:changed', updateCompat);
    updateCompat();
    var grid = document.getElementById('ProductGridContainer');
    if (grid && window.MutationObserver) {
      new MutationObserver(function () { updateCompat(); }).observe(grid, { childList: true });
    }
  }

  /* ---------- Badge de compatibilité (fiche produit) ---------- */
  function updateBadge() {
    var b = document.querySelector('[data-spa-badge]');
    if (!b) return;
    var txt = b.querySelector('[data-spa-badge-txt]');
    var act = b.querySelector('[data-spa-badge-act]');
    var universel = b.getAttribute('data-compat-universel') === 'true';
    var ids = (b.getAttribute('data-compat-ids') || '').split(/\s+/).filter(Boolean);
    var note = (b.getAttribute('data-compat-note') || '').trim();
    var sel = get();
    var anOk = anneeConvient(b.getAttribute('data-compat-annees'), sel);
    var listeOk = ids.length > 0 && !!sel && ids.indexOf(sel.handle) >= 0 && anOk;
    b.classList.remove('is-ok', 'is-no', 'is-neutral');
    /* Une note SEULE est une condition d'EQUIPEMENT a laquelle le selecteur ne sait
       pas repondre : elle l'emporte. Mais si la fiche porte AUSSI une liste de
       modeles et que le modele choisi y est, la note n'est plus qu'une RESERVE :
       on annonce la compatibilite et on la nuance juste en dessous. Sans ca, un
       proprietaire de Vacanza lirait la reserve « spa de nage » a la place de sa
       propre compatibilite. */
    if (note && !listeOk) {
      b.classList.add('is-neutral');
      // Si l'annee est connue, on la rappelle : cette note existe justement
      // parce que la piece depend de l'annee de production.
      if (txt) {
        txt.innerHTML = esc(note)
          + (sel && sel.annee
             ? ' <strong>Votre ' + esc(sel.label) + ' est de ' + sel.annee + '.</strong>'
             : '');
      }
      if (act) act.hidden = true;
      return;
    }
    if (universel) {
      b.classList.add('is-ok');
      if (txt) txt.textContent = 'Compatible avec tous les spas';
      if (act) act.hidden = true;
    } else if (sel) {
      if (ids.indexOf(sel.handle) >= 0 && anOk) {
        b.classList.add('is-ok');
        if (txt) txt.innerHTML = 'Compatible avec votre <strong>' + esc(sel.label) + '</strong>'
          + (sel.annee ? ' <span class="spa-badge__an">(' + sel.annee + ')</span>' : '')
          + (note ? '<span class="spa-badge__res">' + esc(note) + '</span>' : '');
        if (act) act.hidden = true;
      } else {
        b.classList.add('is-no');
        if (txt) txt.innerHTML = 'Non prévu pour votre <strong>' + esc(sel.label) + '</strong>'
          + (sel.annee ? ' <span class="spa-badge__an">(' + sel.annee + ')</span>' : '');
        if (act) { act.hidden = false; act.textContent = 'Changer de spa'; }
      }
    } else {
      b.classList.add('is-neutral');
      if (txt) txt.textContent = 'Vérifiez la compatibilité avec votre spa';
      if (act) { act.hidden = false; act.textContent = 'Indiquer mon spa'; }
    }
  }
  if (document.querySelector('[data-spa-badge]')) {
    document.addEventListener('spa:changed', updateBadge);
    updateBadge();
  }

  /* ---------- preselection par l'URL ----------
     Un lien peut arriver avec `?spa=<handle>` : une page de gamme envoie ainsi
     « voici les articles pour VOTRE modele » sans que la visiteuse re-choisisse.
     Pose ICI, apres l'enregistrement des ecouteurs `spa:changed` (l.812 et 876),
     sinon la barre de compatibilite ne verrait pas passer la selection.
     🛑 On n'accepte qu'un handle CONNU : un parametre invente ne doit pas creer
     une selection fantome. Sans le parametre, rien ne change — le comportement
     d'avant est strictement conserve. */
  try {
    var spaURL = new URLSearchParams(window.location.search).get('spa');
    if (spaURL && BY_HANDLE[spaURL]) {
      var dejaSel = get();
      if (!dejaSel || dejaSel.handle !== spaURL) set(spaURL);
    }
  } catch (e) {}

  renderPills();
  window.CalderaSpa = { get: get, set: set, clear: clear, open: open, MODELS: MODELS };
})();


/* ================= Page modèle : « mon spa est de l'année … » =================
   Une seule page par modèle, qui se restreint. Pas 102 pages qui se ressemblent.
   🛑 On ne touche QUE le segment « — réf. … » d'un <li>. Un rayon sans référence
      (traitement de l'eau, nettoyage, couvertures, accessoires) est laissé
      intact : c'est sa consigne du 15/09, et c'est structurel, pas un réglage. */
(function () {
  var el = document.getElementById('spa-modele-data');
  if (!el) return;
  var D; try { D = JSON.parse(el.textContent); } catch (e) { return; }

  var REFS = {};
  (D.refs || []).forEach(function (r) {
    if (!r || !r.sku) return;
    var a = r.an;
    REFS[String(r.sku)] = (Object.prototype.toString.call(a) === '[object Array]')
      ? [+a[0], (a[1] === null || a[1] === undefined) ? null : +a[1]]
      : [+a, null];                       // un nombre seul = « à partir de »
  });
  var nRefs = 0; for (var k in REFS) if (REFS.hasOwnProperty(k)) nRefs++;
  if (!nRefs) return;                     // rien de daté : pas de sélecteur

  var m = String(D.annees || '').match(/(\d{4})\D+(\d{4})/);
  if (!m) return;                         // modèle d'une seule année : pas de choix
  var AN1 = +m[1], AN2 = +m[2];
  if (AN2 <= AN1) return;

  /* 🛑 La liste des rayons, et surtout PAS le menu de l'en-tête : il est lui aussi une
     .shopify-section et il porte des liens de collection (21 <li> attrapés le 15/09,
     zéro référence). Le critère qui ne peut pas se tromper : la liste du corps est la
     seule qui contienne « réf. ». */
  var ul = null;
  var tous = document.querySelectorAll('ul');
  for (var i = 0; i < tous.length; i++) {
    if (tous[i].textContent.indexOf('réf.') >= 0 && tous[i].querySelector('a[href^="/collections/"]')) {
      ul = tous[i]; break;
    }
  }
  if (!ul) return;

  // la phrase de comptage, pour qu'elle reste vraie quand on filtre
  var pCompte = null, compteOrig = 0;
  var ps = document.querySelectorAll('p');
  for (var j = 0; j < ps.length; j++) {
    var mm = ps[j].textContent.match(/Les (\d+) pièces/);
    if (mm) { pCompte = ps[j]; compteOrig = +mm[1]; break; }
  }
  var compteHTML = pCompte ? pCompte.innerHTML : '';

  var RE_REF_G = /réf\.\s*[0-9A-Za-z\-]+/g;
  var RE_REF_TETE = /réf\.\s*/;
  /* Le paragraphe « Le filtre de ce modèle » : sur UN seul modèle (Cantabria) il cite
     deux cartouches, et l'année tranche. On n'y touche pas le texte — on ajoute
     dessous une ligne qui répond. Rien ne disparaît : c'est sa consigne. */
  var pFiltre = null;
  for (var f = 0; f < ps.length; f++) {
    if (ps[f].textContent.indexOf('filtre de ce modèle') >= 0) { pFiltre = ps[f]; break; }
  }
  var refsFiltre = [];
  if (pFiltre) {
    (pFiltre.textContent.match(RE_REF_G) || []).forEach(function (x) {
      var r = x.replace(RE_REF_TETE, '');
      if (REFS[r] && refsFiltre.indexOf(r) < 0) refsFiltre.push(r);
    });
  }
  var ligneFiltre = null;
  if (pFiltre && refsFiltre.length > 1) {
    ligneFiltre = document.createElement('p');
    ligneFiltre.className = 'spa-an__rep';
    ligneFiltre.setAttribute('aria-live', 'polite');
    ligneFiltre.hidden = true;
    pFiltre.parentNode.insertBefore(ligneFiltre, pFiltre.nextSibling);
  }

  var lis = [].slice.call(ul.querySelectorAll('li'));
  lis.forEach(function (li) { li.setAttribute('data-orig', li.innerHTML); });

  var RE_REF = /réf\.\s*([0-9A-Za-z\-]+(?:\s*,\s*[0-9A-Za-z\-]+)*)/;

  function filtrer(an) {
    var retires = 0;
    lis.forEach(function (li) {
      var orig = li.getAttribute('data-orig');
      if (!an) { li.innerHTML = orig; return; }
      var mr = orig.match(RE_REF);
      if (!mr) { li.innerHTML = orig; return; }   // rayon sans référence : intact
      var gardes = mr[1].split(',').map(function (x) { return x.trim(); })
        .filter(function (r) {
          var b = REFS[r];
          if (!b) return true;                    // non daté = valable partout
          if (an < b[0]) { retires++; return false; }
          if (b[1] !== null && an > b[1]) { retires++; return false; }
          return true;
        });
      li.innerHTML = gardes.length
        ? orig.replace(RE_REF, 'réf. ' + gardes.join(', '))
        : orig.replace(/\s*(&mdash;|—)\s*/, '').replace(RE_REF, '');
    });
    if (ligneFiltre) {
      if (!an) { ligneFiltre.hidden = true; }
      else {
        var okf = refsFiltre.filter(function (r) {
          var b = REFS[r];
          return an >= b[0] && (b[1] === null || an <= b[1]);
        });
        retires += refsFiltre.length - okf.length;
        ligneFiltre.hidden = false;
        ligneFiltre.innerHTML = okf.length === 1
          ? 'Pour un spa de ' + an + ' : cartouche <strong>r\u00e9f. ' + okf[0] + '</strong>.'
          : (okf.length > 1
             ? 'Pour un spa de ' + an + ' : r\u00e9f. ' + okf.join(' ou r\u00e9f. ') +
               ' \u2014 la bascule est en cours d\u2019ann\u00e9e, le num\u00e9ro de s\u00e9rie tranche.'
             : 'Pour un spa de ' + an + ', nous ne r\u00e9f\u00e9ren\u00e7ons pas encore la cartouche.');
      }
    }
    if (pCompte) {
      pCompte.innerHTML = an
        ? compteHTML.replace(/Les \d+ pièces/, 'Les ' + (compteOrig - retires) + ' pièces')
        : compteHTML;
    }
  }

  // ---- la barre
  var id = 'spa-an-' + Math.random().toString(36).slice(2, 7);
  var bar = document.createElement('div');
  bar.className = 'spa-an';
  var opts = '<option value="">toutes les années</option>';
  for (var y = AN2; y >= AN1; y--) opts += '<option value="' + y + '">' + y + '</option>';
  bar.innerHTML =
    '<label class="spa-an__lab" for="' + id + '">Mon spa est de l\u2019année</label>' +
    '<select class="spa-an__sel" id="' + id + '">' + opts + '</select>' +
    '';
  ul.parentNode.insertBefore(bar, ul);
  var sel = bar.querySelector('select');

  sel.addEventListener('change', function () { filtrer(sel.value ? +sel.value : 0); });

  // Si elle a déjà décodé son numéro de série, son année est connue : on s'en sert.
  try {
    // 🛑 Passer par l'API exposée, jamais recopier le nom de la clé : il porte
    // celui de la boutique (`calderabis_spa`) et il y a un repli par cookie.
    var s = window.CalderaSpa && window.CalderaSpa.get();
    if (s && s.handle === D.spa && s.annee && +s.annee >= AN1 && +s.annee <= AN2) {
      sel.value = String(s.annee);
      filtrer(+s.annee);
    }
  } catch (e) {}
})();


/* ============ Fiche produit : présélectionner le modèle déjà choisi ============
   Elle choisit son E700, arrive sur la couverture de spa de nage, et doit
   re-cliquer E700 : le sélecteur de variante ignorait « Mon spa » (15/09).
   🛑 Bloc séparé : il ne voit pas la fermeture principale. Tout est local. */
(function () {
  var groupes = document.querySelectorAll('.pvar');
  if (!groupes.length) return;
  var sel = null;
  // 🛑 Même raison : l'API, pas le nom de la clé recopié.
  try { sel = window.CalderaSpa && window.CalderaSpa.get(); } catch (e) {}
  if (!sel || !sel.handle) return;

  /* Accents dépliés AVANT la réduction : sinon « Réunion » ne rencontre jamais
     « Reunion » — panne déjà payée le 08/09 sur les appuis-tête. */
  function norm(s) {
    return String(s || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase().replace(/[^a-z0-9]/g, '');
  }
  var cle = norm(sel.handle);
  if (!cle) return;

  function poser() {
    for (var i = 0; i < groupes.length; i++) {
      var lab = groupes[i].querySelector('.pvar__label');
      // Un groupe de coloris ne doit pas être touché : on n'agit que sur un
      // groupe qui parle de spa ou de modèle.
      if (!lab || !/spa|mod[eè]le/i.test(lab.textContent)) continue;
      var opts = groupes[i].querySelectorAll('.pvar__opt');
      for (var j = 0; j < opts.length; j++) {
        if (opts[j].hidden) continue;
        var tete = norm((opts[j].getAttribute('data-val') || '').split('\u2022')[0]);
        if (tete.length < 2) continue;
        if (cle.slice(-tete.length) === tete) {
          if (!opts[j].classList.contains('is-active')) opts[j].click();
          return;
        }
      }
    }
  }
  // La fiche pose son propre sélecteur pendant l'analyse du document ; on passe après.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(poser, 0); });
  } else { setTimeout(poser, 0); }
})();
